<template>
  <v-container grid-list-xl>
    <v-layout row wrap justify-center class="ma-5">
      <v-flex xs12 sm6 lg4>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline">Otváracie hodiny</div>
          </v-card-title>
          <v-card-text class="layout justify-center">
            <v-list class="transparent">
              <v-list-tile v-for="(day, index) in openingHours" :key="index">
                <v-list-tile-action>
                  <v-icon :class="`${day.color}--text`">{{day.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-html="day.title"></v-list-tile-title>
                  <v-list-tile-sub-title v-if="day.subtitle" v-html="day.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline">Kontaktujte nás</div>
          </v-card-title>
          <v-card-text class="layout justify-center">
            <v-list class="transparent">
              <v-list-tile v-for="(info, index) in contactInfo" :key="index">
                <v-list-tile-action>
                  <v-icon :class="`${info.color}--text`">{{info.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <a v-if="info.link" :href="info.link" target="_blank" v-html="info.title"></a>
                  <v-list-tile-title v-else v-html="info.title"></v-list-tile-title>
                  <v-list-tile-sub-title v-if="info.subtitle" v-html="info.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-divider></v-divider> -->
    <!-- <v-layout row wrap justify-center class="my-5">
        <v-flex xs12 sm4>
          <div id="m" ref="myid" style="height:380px"></div>
      </v-flex>
    </v-layout>-->
  </v-container>
</template>

<script>
export default {
  name: "Contact",
  components: {},
  data() {
    return {
      openingHours: [
        {
          title: "Pondelok - 7.00 hod - 15.30 hod",
          icon: "sentiment_very_satisfied",
          color: "success"
        },
        {
          title: "Utorok - 7.00 hod - 15.30 hod",
          icon: "sentiment_very_satisfied",
          color: "success"
        },
        {
          title: "Streda - 7.00 hod - 15.30 hod",
          icon: "sentiment_very_satisfied",
          color: "success"
        },
        {
          title: "Štvrtok - 7.00 hod - 15.30 hod",
          icon: "sentiment_very_satisfied",
          color: "success"
        },
        {
          title: "Piatok - 7.00 hod - 15.30 hod",
          icon: "sentiment_very_satisfied",
          color: "success"
        },
        {
          title: "Sobota - 9.00 hod - 11.00 hod",
          subtitle: "na objednávku",
          icon: "sentiment_satisfied",
          color: "warning"
        },
        {
          title: "Nedeľa - zatvorené",
          icon: "sentiment_very_dissatisfied",
          color: "error"
        }
      ],
      contactInfo: [
        { title: "duris@duris.info", icon: "email", color: "info" },

        {
          title: "+421 911 607 212",
          subtitle: "cez týždeň",
          icon: "phone_iphone",
          color: "info"
        },
        {
          title: "+421 905 428 225",
          subtitle: "cez týždeň / cez víkend",
          icon: "phone_iphone",
          color: "info"
        },
        {
          title: "92064, Kľačany 330",
          icon: "place",
          color: "error",
          link:
            "https://www.google.sk/maps/place/K%C4%BEa%C4%8Dany+330,+920+64+K%C4%BEa%C4%8Dany/@48.3775368,17.874712,17z/data=!3m1!4b1!4m5!3m4!1s0x476b4485032b6c29:0xd9c28245b8cdcb8d!8m2!3d48.377536!4d17.8769"
        }
      ]
    };
  }
  // created() {

  // },
  // mounted() {
  //   var stred = window.SMap.Coords.fromWGS84(14.41, 50.08)
  //   var mapa = new window.SMap(document.getElementById('m'), stred, 10)
  //   mapa.addDefaultLayer(window.SMap.DEF_BASE).enable()
  //   mapa.addDefaultControls()
  // }
};
</script>

<style>
</style>